import { useState, useEffect, useRef } from "react";

const combineChartDimensions = (dimensions) => {
  const parsedDimensions = {
    marginTop: dimensions.marginTop,
    marginRight: dimensions.marginRight,
    marginBottom: dimensions.marginBottom,
    marginLeft: dimensions.marginLeft,
    boundedHeight: Math.max(
      dimensions.height - dimensions.marginTop - dimensions.marginBottom,
      0
    ),
    boundedWidth: Math.max(
      dimensions.width - dimensions.marginLeft - dimensions.marginRight,
      0
    ),
  };

  return {
    ...parsedDimensions,
    margin: {
      top: dimensions.marginTop,
      right: dimensions.marginRight,
      bottom: dimensions.marginBottom,
      left: dimensions.marginLeft,
    },
  };
};

export const useChartDimensions = (passedSettings) => {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (ref.current) {
      const element = ref.current;
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries)) return;
        if (!entries.length) return;

        const entry = entries[0];
        if (width !== entry.contentRect.width)
          setWidth(entry.contentRect.width);
        if (height !== entry.contentRect.height)
          setHeight(entry.contentRect.height);
      });

      resizeObserver.observe(element);

      return () => resizeObserver.unobserve(element);
    }
  }, []);

  const newSettings = {
    ...passedSettings,
    width: passedSettings.width || width,
    height: passedSettings.height || height,
  };

  return [ref, combineChartDimensions(newSettings)];
};
